<div class="job-exec">
  <div class="job-exec__header bz-space--stack-l">
    <label>{{'AIJOBS.EXECUTION_DESCRIPTION' | translate}}</label>
    <bzg-checkbox [(ngModel)]="showOnlyErrors" (ngModelChange)="applyErrorFilter()" required="false">
      {{'AIJOBS.SHOW_ERROR_RESULT' | translate}}
    </bzg-checkbox>
  </div>
  <div class="job-exec__content">
    <div class="job-exec__content__table bz-table--responsive">
      <table class="bz-table">
          <thead>
              <tr>
                <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns">
                  <div class="bz-table__col-title" *ngIf="col.visible">
                    <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
                    <div class="bz-table__col-sort">
                      <bzg-icon [nameIcon]="'icon-arrow-down-table'" (click)="sortByColumn(col.key, 1)"
                        *ngIf="sortOptions.columnName === '' || (sortOptions.columnName === col.key && sortOptions.orderType === 0) || sortOptions.columnName !== col.key ">
                      </bzg-icon>
                      <bzg-icon [nameIcon]="'icon-arrow-up-table'" (click)="sortByColumn(col.key, 0)"
                        *ngIf="sortOptions.columnName === col.key && sortOptions.orderType === 1">
                      </bzg-icon>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          <tbody>
              <tr *ngFor="let log of jobLogs">
                  <td class="bz-table__cell" *ngFor="let col of columns">
                    <div *ngIf="col.visible">
                      <div class="bz-table__cell-row" *ngIf="col.type === 'link' "><a class="bz-link bmc-jobs-table__link">{{ log[col.key] }}</a></div>
                      <div class="bz-table__cell-row" *ngIf="col.type === 'text'">{{ log[col.key] }}</div>
                      <div class="bz-table__cell-row" *ngIf="col.type === 'date' ">{{ log[col.key] | userTimezoneFormat:1 }}</div>
                      <div class="bz-table__cell-row" *ngIf="col.type === 'boolean'">
                        {{ log[col.key] === true ? ('EVENTS_LOG.SUCCESS' | translate) : ('EVENTS_LOG.ERROR' | translate) }}
                      </div>
                      <div *ngIf="col.type === 'result'">
                        <div class="job-exec__row-result">
                          <bzg-icon [nameIcon]="log.jobExecutionResult ? 'icon-check-mark': 'icon-warning'" [color]="log.jobExecutionResult ? 'success': 'error'" class="bz-space--inline-s">
                          </bzg-icon>
                          <a *ngIf="log[col.key]" (click)="openMessageModal(log[col.key])" class="job-exec__result-msg-link">{{ 'GLOBAL.VIEW_MESSAGE' | translate }}</a>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
          </tbody>
      </table>
  </div>
  <div class="bz-table-pagination" >
    <bzg-paginator [pageSize]="10" [totalItems]="jobLogsTotal" [pageSizeOptions]="[10, 30, 50, 100, 200, 500]"
      (paginationChanged)="onPaginationEvent($event)">
    </bzg-paginator>
  </div>
  </div>
  <div class="job-exec__footer">
  </div>
</div>
